export default __webpack_public_path__ + "static/Edita_Prima_photo_bg_cases_page-ce0d32096830cd4722f3c42f7539b1f7.jpg";